<template>
    <div class="qr-code">
        <h3><b>{{ $t('presence') }}</b></h3>

        <qrcode ref="qrCode" :value="url" :options="{ width: 300 }" tag="img"></qrcode>
        <div class="q-mb-md">
            {{ url }}
            <q-btn 
                class="q-pa-sm q-mx-xs"
                icon="far fa-copy"
                :aria-label="$t('copy_link')"
                :title="$t('copy_link')"
                @click="copyToClipboard"
            />
        </div>

        <q-btn 
            class="q-pa-sm q-mx-xs"
            icon="far fa-print"
            :label="$t('print')"
            @click="printQrCode"
        />
    </div>
</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode'

export default {
    name: 'Presence',

    components: { 'qrcode': VueQrcode },
    
    props:['url'],

    methods: {
        async printQrCode() {
            const qrCodeImage = this.$refs.qrCode.$el;
            
            const printWindow = window.open('', '_blank');
            printWindow.document.write(`
                <html>
                <head>
                    <title>Print QR Code</title>
                </head>
                <body style="display:flex;justify-content:center;align-items:center;">
                    <img src="${qrCodeImage.src}" style="width:700px;max-width:100%;height:auto;">
                </body>
                </html>
            `);
            printWindow.document.close();

            // Adicione um pequeno atraso antes de chamar a impressão
            setTimeout(() => {
                printWindow.print();
                printWindow.close();
            }, 500);
        },
        copyToClipboard() {
            navigator.clipboard.writeText(this.url).then(() => {
                this.$q.notify({
                    type: 'positive',
                    message: this.$t('link_copied_to_clipboard'),
                });
            }).catch(err => {
                console.error('Error copying text: ', err);
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('fail'),
                });
            });
        }
    },
}
</script>

<style scoped>
    .qr-code {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
</style>
